import { ApprovalStatus } from '@/entities/approvals/constants';
import { TagType } from '@/ui/components/Tag';

export const approvalStatusTagClass = (status: ApprovalStatus): TagType => (({
  [ApprovalStatus.Approved]: 'success',
  [ApprovalStatus.Rejected]: 'error',
  [ApprovalStatus.ChangesRequested]: 'warning',
}) as Record<ApprovalStatus, string>)[status] as TagType || 'primary';
